import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { UserAddOutlined, FormOutlined } from '@ant-design/icons';

const OtcContainer = styled.div`
  min-height: calc(100vh - 200px);
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  padding: 2rem 0;
`;

const ContentWrapper = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 0 2rem;
`;

const PageTitle = styled.h1`
  text-align: center;
  color: #efb348;
  font-size: 2.5rem;
  margin-bottom: 3rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
`;

const Section = styled.section`
  background: rgba(0, 0, 0, 0.7);
  border-radius: 12px;
  padding: 2rem;
  margin-bottom: 2rem;
  color: white;
  text-align: center;

  h2 {
    margin-bottom: 1.5rem;
    color: #efb348;
    font-size: 1.5rem;
  }

  p {
    margin-bottom: 1.5rem;
    color: rgba(255, 255, 255, 0.9);
    line-height: 1.6;
  }

  .otc-icon {
    display: block;
    margin-bottom: 1rem;
    color: #efb348;
    font-size: 3rem;
  }

  a {
    display: inline-block;
    margin-top: 1rem;
    color: #42a5f5;
    font-weight: bold;
    text-decoration: none;
    transition: color 0.2s;

    &:hover {
      color: #81d4fa;
      text-decoration: underline;
    }
  }
`;

const AssistanceSection = styled.section`
  background: rgba(239, 179, 72, 0.1);
  border: 1px solid #efb348;
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
  color: white;
  margin-bottom: 2rem;

  p {
    margin-bottom: 1rem;
    color: rgba(255, 255, 255, 0.9);
  }

  img {
    margin-bottom: 1rem;
    border-radius: 8px;
  }

  .highlight {
    color: #efb348;
    font-weight: bold;
    font-size: 1.1rem;
  }
`;

const Otc = () => {
  const { t } = useTranslation();

  return (
    <OtcContainer>
      <ContentWrapper>
        <PageTitle>{t('otc.title')}</PageTitle>

        <Section>
          <UserAddOutlined className="otc-icon" />
          <h2>{t('otc.registration.title')}</h2>
          <p>{t('otc.registration.description')}</p>
          <a
            href="https://form.jotform.com/221240572282044"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('otc.registration.linkText')}
          </a>
        </Section>

        <Section>
          <FormOutlined className="otc-icon" />
          <h2>{t('otc.order.title')}</h2>
          <p>{t('otc.order.description')}</p>
          <a
            href="https://form.jotform.com/221722338922858"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('otc.order.linkText')}
          </a>
        </Section>

        {/* Assistance Section copied from Contact page */}
        <AssistanceSection>
          <p>{t('contact.registration.assistance')}</p>
          <img src="/images/tunion-qr.jpeg" width={200} alt="Contact QR Code" />
          <p className="highlight">{t('contact.registration.mobile')}</p>
        </AssistanceSection>
      </ContentWrapper>
    </OtcContainer>
  );
};

export default Otc;
